import { render, staticRenderFns } from "./CreateReelReminderOrder.vue?vue&type=template&id=78c8cc44&scoped=true&"
import script from "./CreateReelReminderOrder.vue?vue&type=script&lang=js&"
export * from "./CreateReelReminderOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateReelReminderOrder.vue?vue&type=style&index=0&id=78c8cc44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c8cc44",
  null
  
)

export default component.exports